<div class="card">
  <div class="card-content">
    <div class="page-header">
      <h4 translationEditableDirective="SETTINGS">{{"SETTINGS" | translate}}</h4>
    </div>

    <div class="tabs is-toggle is-fullwidth">
      <ul>
        <li [ngClass]="{ 'is-active': tab === 'general' }">
          <a [routerLink]="['general']">
            <span translationEditableDirective="GENERAL">{{"GENERAL" | translate}}</span>
          </a>
        </li>
        <li [ngClass]="{ 'is-active': tab === 'filesystem' }">
          <a [routerLink]="['filesystem']">
            <span translationEditableDirective="FILESYSTEM">{{"FILESYSTEM" | translate}}</span>
          </a>
        </li>
        <li [ngClass]="{ 'is-active': tab === 'gis' }">
          <a [routerLink]="['gis']">
            <span translationEditableDirective="GIS">{{"GIS" | translate}}</span>
          </a>
        </li>
        <li [ngClass]="{ 'is-active': tab === 'email' }">
          <a [routerLink]="['email']">
            <span translationEditableDirective="EMAIL">{{"EMAIL" | translate}}</span>
          </a>
        </li>
        <li [ngClass]="{ 'is-active': tab === 'security' }">
          <a [routerLink]="['security']">
            <span translationEditableDirective="SECURITY">{{"SECURITY" | translate}}</span>
          </a>
        </li>
      </ul>
    </div>

    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
